
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sets/[setCode]",
      function () {
        return require("private-next-pages/sets/[setCode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sets/[setCode]"])
      });
    }
  